/**
 * 현물시세(metal_price_history) API 호출 모듈.
 *
 * axios 인스턴스(src/api/index.js)를 공통으로 사용하며,
 * 인증 토큰은 index.js 인터셉터에서 자동으로 Authorization 헤더에 주입된다.
 *
 * 권한: HQ(본사) 관리자만 접근 가능
 */
import api from './index'

/* ================================================================
 * 현물시세 API
 * ================================================================ */

/**
 * 현물시세 차트 데이터 조회.
 *
 * 기간(startDate ~ endDate) 조건으로 금(GOLD)/은(SILVER) 시세 이력을 조회한다.
 * 응답 데이터는 ECharts Spline 차트의 gold/silver 시리즈로 바로 사용 가능하다.
 *
 * @param {Object} params - 조회 파라미터
 *   @param {string} [params.startDate] - 조회 시작일 (yyyy-MM-dd), 생략 시 전체
 *   @param {string} [params.endDate]   - 조회 종료일 (yyyy-MM-dd), 생략 시 전체
 * @returns {Promise} {
 *   code: number,
 *   message: string,
 *   data: {
 *     gold: Array<{ quotedAt: string, priceKrwPerG: number }>,
 *     silver: Array<{ quotedAt: string, priceKrwPerG: number }>
 *   }
 * }
 */
export function getMetalPriceChartData(params) {
  return api.get('/api/v1/metal-price', { params })
}
